import React, { useState } from 'react'
import { Button, Radio, Input, Form, Tree, Tabs, Row, Col, Flex, Splitter, Typography, ConfigProvider } from 'antd'
import './PdfEdit.less'
import type { TreeDataNode, TabsProps } from 'antd';

const Desc: React.FC<Readonly<{ text?: string | number }>> = (props) => (
  <Flex justify="center" align="center" style={{ height: '100%' }}>
    <Typography.Title type="secondary" level={5} style={{ whiteSpace: 'nowrap' }}>
      {props.text}
    </Typography.Title>
  </Flex>
);

const treeData: TreeDataNode[] = [
  {
    title: 'MR报告模板',
    key: '0-0',
    children: [
      {
        title: '01头颅',
        key: '0-0-0',
        children: [
          {
            title: '01正常',
            key: '0-0-0-0',
            children: [
              {
                title: '01正常(平扫)',
                key: '0-0-0-0-0',
              },
              {
                title: '02正常(增强)',
                key: '0-0-0-0-1',
              },
            ]
          },
        ],
      },
      {
        title: '02颈部',
        key: '0-0-1',
        children: [
          {
            title: '00颈部MRA',
            key: '0-0-1-0',
            children: [
              {
                title: '01颈部C4-5/5-6锥间盘突出',
                key: '0-0-1-0-0',
              }
            ]
          },
        ],
      }
    ],
  }
];

const items: TabsProps['items'] = [
  {
    key: '1',
    label: '模板明细',
    children: '模板明细内容',
  },
  {
    key: '2',
    label: '修改痕迹',
    children: '修改痕迹内容',
  }
];

const PdfEdit = () => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { TextArea } = Input;

  const onSelect = (selectedKeys: React.Key[], info: any) => {
    console.log('selected', selectedKeys, info);
  };

  const handleChangeEdit = (flag) => {
    setIsEdit(flag)
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Radio: {
            colorPrimary: '#84b9c8',
            buttonPaddingInline: 20
          },
          Input: {
            activeBg: '#ffffff',
            activeBorderColor: '#2e3440',
            hoverBorderColor: '#2e3440'
          },
          Form: {
            labelColor: '#fff'
          }
        },
      }}
    >
      <div className="pdfEdit_page">
        {/* 头部按钮 */}
        <div className="pdf_top">
          <Button type="primary" onClick={() => handleChangeEdit(true)} disabled={isEdit}>编辑</Button>
          <Button type="primary" disabled>保存</Button>
          <Button type="primary" disabled>审核</Button>
          <Button type="primary" disabled={!isEdit} onClick={() => handleChangeEdit(false)}>取消</Button>
          <Button type="primary" disabled>打印</Button>
        </div>
        {/* 下面内容 */}
        <div className="pdf_bottom">
          <Splitter style={{ height: '100%', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
            <Splitter.Panel collapsible defaultSize="15%">
              <Splitter layout="vertical">
                <Splitter.Panel>
                  <div className="pdf_template_title">
                    <h3>报告模板</h3>
                  </div>
                  <div className="pdf_template_left_content">
                    <div className='radio_box'>
                      <Radio.Group >
                        <Radio value="add">追加模板</Radio>
                        <Radio value="replace">替换模版</Radio>
                      </Radio.Group>
                    </div>
                    <Tree
                      defaultExpandedKeys={['0-0-0']}
                      onSelect={onSelect}
                      treeData={treeData}
                    />
                  </div>
                </Splitter.Panel>
                <Splitter.Panel>
                  <div className='tab_box'>
                    <Tabs defaultActiveKey="1" items={items} type="card" size="small" />
                  </div>
                </Splitter.Panel>
              </Splitter>
            </Splitter.Panel>
            <Splitter.Panel>
              <Form
                // labelCol={{ span: 12 }}
                // wrapperCol={{ span: 16 }}
                layout="horizontal"
                disabled={!isEdit}
                style={{ maxWidth: 800 }}
              >
                <Row>
                  <Col span={6}>
                    <Form.Item label="患者姓名" name="chinese_name" >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="性别" name="sex">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="年龄" name="age">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="全院号" name="patient_id">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="住院号" name="in_no" >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="门诊号" name="out_no">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="检查号" name="study_id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="检查部位" name="bodypart_name">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="送检部门" name="register_dept" >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="送检人员" name="register_man">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="临床诊断" name="clinicalDiagnosis" >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item label="检查部位" name="checkSite" >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="检查名称" name="checkName" >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="检查方法" name="diagnosticMethod" >
                      <TextArea autoSize={{ minRows: 3, maxRows: 4 }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="检查所见" name="checkLook">
                      <TextArea autoSize={{ minRows: 6, maxRows: 7 }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="诊断结果" name="diagnosticResult" >
                      <TextArea autoSize={{ minRows: 6, maxRows: 7 }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="检查建议" name="diagnosticAdvice" >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <Form.Item label="报告时间" name="reportTime" >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="报告医师" name="reportDoctor">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="审核时间" name="checkTime">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="审核医师" name="checkDoctor">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Splitter.Panel>
          </Splitter>
        </div>
      </div>
    </ConfigProvider>
  )
}

export default PdfEdit
